/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */

/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */

/* ====== Component Js/Jsx ====== */
import { SubtitleIcon } from '02CommonUiParts/OtherParts/SubtitleIcon';
import { assets } from '03CommonApiParts/Configuration';
import { screenDisplayMessage } from '03CommonApiParts/MessageList';

/* ====== CSS ====== */
import styled from 'styled-components';

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  


/* ====== Styled Components ====== */
const GdivPageTitleStyle = styled.div`//ページタイトル
    display:flex;
    width:25%;
    white-space: nowrap;   
    color : #2E94B9;
    font-weight:bold;
`;
const GdivTitleWrapperStyle = styled.div`//タイトル枠
    display: flex;
    align-items: center;
    /* margin: 5px 0 0 10px; */
`;
/* ------サブタイトル ------*/
const GdivSubTitleWrapperStyle = styled.div`//サブタイトル枠
    display: flex;
    align-items: center;
    color: #2E94B9;
    font-weight: bolder;
    margin: 4px 0;
    scroll-margin-top: 120px;
    white-space: nowrap;
    margin-right: 10px;
`;
/* ------ページコンテンツ ------*/
const GdivPageContentsWrapperStyle = styled.div`//ページコンテンツ枠
    margin:0px 10px 0px 10px;
`;
const GdivChangeOrderTextStyle  = styled.div`
    margin-top: -4px;
`;

const GdivConfirmTextStyle  = styled.div`
    margin:0px 10px 0px 10px;
    font-weight:bold;
`

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */

export const StyleCommon = () => {

    /* ====== ページタイトル ====== */
     const GdivPageTitle = ({children} ) => {
        return(
            <GdivPageTitleStyle  className='titleText' style={{fontSize:assets().size.headText}}>{children}</GdivPageTitleStyle>
        )
    }
    /* ====== タイトル枠 ====== */
     const GdivTitleWrapper = ({  children} ) => {
        return(
            <GdivTitleWrapperStyle  className='titleText'style={{fontSize:assets().size.titleText}}>{children}</GdivTitleWrapperStyle>
        )
    }
    /* ====== サブタイトル枠 ====== */
     const GdivSubTitleWrapper = ({ id, children, style} ) => {
        return(
            <GdivSubTitleWrapperStyle  className='titleText' id={id} style={{...style, fontSize:assets().size.titleText}}>
                <SubtitleIcon/>
                {children}
            </GdivSubTitleWrapperStyle>
        )
    }

    /* ====== ページコンテンツ枠 ====== */
     const GdivPageContentsWrapper = ({ children }) => {
        return (
            <GdivPageContentsWrapperStyle  className='titleText' style={{fontSize:assets().size.baseText}}>{children}</GdivPageContentsWrapperStyle>
        );
    };

    const GdivChangeOrderText = ({children}) => {
        return(
            <GdivChangeOrderTextStyle style={{fontSize:assets().size.inputlabelText}}>{children}</GdivChangeOrderTextStyle>
        )
    }

    /* ======　確認文言 ====== */
    const GdivConfirmText = ({mode}) => {
        let result = {};
        switch(mode){
            case 'registerConfirm' :
                result.color = 'red'; //赤文字
                result.message = screenDisplayMessage('CMNI001'); //登録確認
                break;
            case 'updateConfirm' :
                result.color = 'red'; //赤文字
                result.message = screenDisplayMessage('CMNI002'); //更新確認
                break;
            case 'deleteConfirm' :
                result.color = 'red'; //赤文字
                result.message = screenDisplayMessage('CMNI003'); //削除確認
                break;
            default:
                result.message = ''
            break;
        }
        return(
                <GdivConfirmTextStyle className="baseText" style={{fontSize:assets().size.baseText,color:result.color}}>{result.message}</GdivConfirmTextStyle>
        )
    }

    return {
        GdivPageTitle,
        GdivTitleWrapper,
        GdivSubTitleWrapper,
        GdivPageContentsWrapper,
        GdivChangeOrderText,
        GdivConfirmText
    }
}

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */